import { AEMManifest } from '@/../css-oom/src/manifest-interface';
import { TrackingEvent } from '@owc/connection-aem-tracking';
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
import { Component, ComponentInterface, h, Host, JSX, Prop, State } from '@stencil/core';

@Component({
  tag: 'css-css-oom-generic',
  styleUrl: 'css-oom-generic.scss',
  shadow: false,
})
export class CssOomGenericComponent implements ComponentInterface {
  @Prop({ reflect: true }) language!: string;
  @Prop({ reflect: true }) country!: string;
  @Prop({ reflect: true }) languageDirection: 'ltr' | 'rtl' = 'ltr';
  @Prop({ reflect: true }) environment: 'test' | 'int' | 'pprod' | 'prod' = 'prod';
  @Prop({ reflect: true }) trackingFn!: (tracking: TrackingEvent) => void;
  @Prop() basePath = '';
  @Prop() errorUrl = '';
  @Prop() notFoundUrl = '';

  @State() assetsBaseUrl = '';
  @State() oomManifest?: AEMManifest;
  @State() oomAssetUrl = '';
  @State() oomStyleUrl = '';

  async componentWillLoad(): Promise<void> {
    this.assetsBaseUrl = this.getAssetsBaseUrl();
    this.oomManifest = await this.fetchOomManifest();
    this.oomAssetUrl = this.getOomAssetUrl();
    this.oomStyleUrl = this.getOomStyleUrl();
  }

  getAssetsBaseUrl(): string {
    const envSubdomains = {
      test: 'test.',
      int: 'int.',
      pprod: 'preprod.',
      prod: '',
    };

    const subdomain = envSubdomains[this.environment] ?? envSubdomains.prod;
    return `https://${subdomain}assets.oneweb.mercedes-benz.com/plugin`;
  }

  fetchOomManifest(): Promise<AEMManifest> {
    const cacheBreaker = new Date().getTime();
    const manifestUrl = `${this.assetsBaseUrl}/css-css-oom/manifest.json?cb=${cacheBreaker}`;
    return fetch(manifestUrl).then((res) => res.json());
  }

  getOomAssetUrl(): string {
    return `${this.assetsBaseUrl}${this.oomManifest?.config.files.scripts[0].url}`;
  }

  getOomStyleUrl(): string {
    return `${this.assetsBaseUrl}${this.oomManifest?.config.files.styles[0].url}`;
  }

  render(): JSX.Element {
    return (
      <Host>
        {/* Workbench styles */}
        <link
          href="https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/7.77.2/css/globals.css"
          rel="stylesheet"
        />
        <link
          href="https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/7.77.2/css/extensions/spacing.css"
          rel="stylesheet"
        />
        <link
          href="https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/7.77.2/css/extensions/components.css"
          rel="stylesheet"
        />

        {/* Workbench components */}
        <script
          type="module"
          src="https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/7.77.2/workbench/workbench.esm.js"
        ></script>

        <link rel="stylesheet" href={this.oomStyleUrl} />

        <div
          data-component-name="css-css-oom"
          /* @ts-expect-error Expect error*/
          language={this.language}
          country={this.country}
          language-direction={this.languageDirection}
          environment={this.environment.toUpperCase()}
          base-path={this.basePath}
          error-url={this.errorUrl}
          not-found-url={this.notFoundUrl}
          asset-uri={`${this.assetsBaseUrl}/css-css-oom/latest`}
          tracking-fn={this.trackingFn}
        ></div>
        <script type="module" src={this.oomAssetUrl}></script>
        <script type="module" src={`${this.assetsBaseUrl}/css-css-oom-generic/latest/adjust-workbench.js`}></script>
      </Host>
    );
  }
}
